import { Modal, Button } from "react-bootstrap";

function CustomModal({ 
  isOpen, 
  title, 
  message, 
  description, 
  primaryButtonText = "Continue", 
  secondaryButtonText = "Close", 
  onPrimaryClick, 
  onSecondaryClick,
  icon
}) {
  return (
    <Modal 
      show={isOpen} 
      onHide={onSecondaryClick} 
      centered 
      backdrop="static" 
      keyboard={false}
      contentClassName="border-0 shadow-lg"
    >
      {/* Modal Header */}
      {title && (
        <Modal.Header 
          closeButton 
          className="border-0"
          style={{ backgroundColor: "var(--bg-secondary)" }}
        >
          <Modal.Title 
            className="fw-bold" 
            style={{ color: "var(--accent-color)" }}
          >
            {title}
          </Modal.Title>
        </Modal.Header>
      )} 

      {/* Modal Body */}
      <Modal.Body className="text-center py-4" style={{ backgroundColor: "var(--bg-primary)" }}>
        <div 
          className="d-flex align-items-center justify-content-center mb-3"
          style={{
            width: "80px",
            height: "80px",
            margin: "0 auto",
            borderRadius: "50%",
            backgroundColor: "rgba(168, 196, 22, 0.1)",
            color: "var(--accent-color)"
          }}
        >
          {icon}
        </div>
        <h5 
          className="fw-semibold" 
          style={{ color: "var(--text-primary)" }}
        >
          {message}
        </h5>
        {description && (
          <div 
            className="mt-3 p-3 rounded"
            role="alert"
            style={{
              backgroundColor: "rgba(168, 196, 22, 0.1)",
              border: "1px solid var(--accent-color)",
              color: "var(--accent-color)"
            }}
          >
            {description}
          </div>
        )}
      </Modal.Body>

      {/* Modal Footer */}
      <Modal.Footer 
        className="border-0 d-flex justify-content-center pb-4"
        style={{ backgroundColor: "var(--bg-primary)" }}
      >
        {onSecondaryClick && (
          <Button 
            variant="outline-secondary" 
            onClick={onSecondaryClick}
            className="px-4 me-2"
            style={{
              borderColor: "var(--border-color)",
              color: "var(--text-secondary)",
              backgroundColor: "transparent"
            }}
          >
            {secondaryButtonText}
          </Button>
        )}
        <Button 
          onClick={onPrimaryClick}
          className="px-4"
          style={{
            backgroundColor: "var(--accent-color)",
            borderColor: "var(--accent-color)",
            color: "#000000",
            fontWeight: "500"
          }}
        >
          {primaryButtonText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CustomModal;
